import * as React from 'react';
import { cn } from 'src/shadcn/lib/utils';

export interface ILogoIconProps {
  className?: string;
}

export const LogoIcon: React.FunctionComponent<ILogoIconProps> = props => {
  return (
    <svg
      id='Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 507.81 630.82'
      className={cn('fill-[#3363ff]', props.className)}
    >
      <title>Sparkify</title>
      <path
        className='cls-1'
        d='M410.45,265.78l-4.39-6.49L485,163.06A99.75,99.75,0,0,0,407.86,0H173.36A171.77,171.77,0,0,0,31.49,268.59L97.31,365l4.4,6.49L22.77,467.77A99.79,99.79,0,0,0,99.91,630.82H334.47A171.75,171.75,0,0,0,476.34,362.23Zm-7.28,229.59a76.65,76.65,0,0,1-68.7,41.38h-6.05L109.2,215.61A77.7,77.7,0,0,1,173.36,94.07h6L398.63,415.21A76.69,76.69,0,0,1,403.17,495.37Z'
      />
    </svg>
  );
};
